import React from "react";
import {
  Card,
  CardContainer,
  CardHeader,
  CardInfo,
  ChipsCard,
  Full,
  PLineHeigth2,
} from "./styled-datafetcher";

import { FlexBox } from "../../styles/global";
import { IoIosPeople } from "react-icons/io";
import { FaClock } from "react-icons/fa";
import { useDataContext } from "../../context/DataContext";
import ReactLoading from "react-loading";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Typography,
} from "@mui/material";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import Tooltip from "@mui/material/Tooltip";

import DetalhadoModal from "./DetalhadoModal";

const DataFetcher: React.FC = () => {
  const {
    tempoMedio7dias,
    selectedEspecialidades,
    setSelectedEspecialidade,
    selectedHospital,
    setSelectedHospital,
    loading,
    metricasEspecialidades,
    especialidades,
    listOptinsEspecialidades,
    macrorregiaoColorMap,
    especialidadesColorMap,
  } = useDataContext();

  const [expanded, setExpanded] = React.useState<string | false>(
    "especialidades"
  );
  const [selectedOption, setSelectedOption] = React.useState(
    selectedEspecialidades
  );
  const [selectedHospitalOption, setSelectedHospitalOption] =
    React.useState(selectedHospital);

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [modalHospital, setModalHospital] = React.useState("");
  const [modalEspecialidade, setModalEspecialidade] = React.useState("");
  const [isHovered, setIsHovered] = React.useState(false);

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(
        newExpanded
          ? panel
          : panel != "hospitais"
          ? "hospitais"
          : "especialidades"
      );
    };

  const handleEspecialidadeChange = (
    event: React.MouseEvent<HTMLElement>,
    especialidade: string
  ) => {
    if (especialidade) {
      setSelectedOption(especialidade);
      setSelectedEspecialidade(especialidade);
      setSelectedHospitalOption("Todos");
      setSelectedHospital("Todos");
    }
  };

  const handleHospitalChange = (
    event: React.MouseEvent<HTMLElement>,
    hospital: string
  ) => {
    if (hospital) {
      setSelectedHospitalOption(hospital);
      setSelectedHospital(hospital);
      setSelectedOption("Todas");
    }
  };

  // Definindo a sequência desejada
  const hospitalOrder = [
    "HRT",
    "HRSam",
    "HRC",
    "HRBz",
    "HSVP",
    "HRG",
    "HRGu",
    "HRAN",
    "HMIB",
    "HRS",
    "HRL",
    "HRPL",
  ];

  const hospitalsList = [
    // "Todos",
    "HRT",
    "HRSam",
    "HRC",
    "HRBz",
    "HSVP",
    "HRG",
    "HRGu",
    "HRAN",
    "HMIB",
    "HRS",
    "HRL",
    "HRPL",
  ];

  function getMetricasRisco(
    risco: string,
    hospital: any,
    tipo: string,
    especialidade: any
  ) {
    const current = especialidade || selectedEspecialidades;
    let valor, resultado;
    if (tipo === "risco") {
      valor = metricasEspecialidades[hospital]?.[current];
      resultado = valor?.reduce((acc: number, item: any) => {
        return acc + (item[`${tipo}_${risco}`] || 0);
      }, 0);
    } else {
      valor = tempoMedio7dias[hospital]?.[current];
      if (valor?.length == 1) {
        resultado = valor?.[0]?.[`${tipo}_${risco}`];
      } else if (valor?.length == 2) {
        if (
          valor?.[0]?.pacientes_aguardando_atendimento == 0 &&
          valor?.[1]?.pacientes_aguardando_atendimento == 0
        ) {
          resultado = "!";
        } else if (valor?.[0]?.pacientes_aguardando_atendimento != 0) {
          resultado = valor?.[0]?.[`${tipo}_${risco}`];
        } else {
          resultado = valor?.[1]?.[`${tipo}_${risco}`];
        }
      } else {
        resultado = "?";
      }
    }

    return resultado;
  }

  function getMetricas(
    hospital: any,
    metrica: string,
    especialidade: any,
    ultimaSemana: boolean = false
  ) {
    const current = especialidade || selectedEspecialidades;
    let valor;
    if (!ultimaSemana) {
      valor = metricasEspecialidades[hospital]?.[current]?.[0]?.[metrica];
    } else {
      if (tempoMedio7dias[hospital]?.[current]?.length == 1) {
        valor = tempoMedio7dias[hospital]?.[current]?.[0]?.[metrica];
      } else if (tempoMedio7dias[hospital]?.[current]?.length == 2) {
        if (
          tempoMedio7dias[hospital]?.[current]?.[0]
            ?.pacientes_aguardando_atendimento == 0 &&
          tempoMedio7dias[hospital]?.[current]?.[1]
            ?.pacientes_aguardando_atendimento == 0
        ) {
          valor = "!";
        } else if (
          tempoMedio7dias[hospital]?.[current]?.[0]
            ?.pacientes_aguardando_atendimento != 0
        ) {
          valor = tempoMedio7dias[hospital]?.[current]?.[0]?.[metrica];
        } else {
          valor = tempoMedio7dias[hospital]?.[current]?.[1]?.[metrica];
        }
      } else {
        valor = "?";
      }
    }
    return valor || 0;
  }

  function verificaHospital(hospital: any, item: any) {
    return [
      "pacientes_desistentes",
      "tempo_atendimento",
      "gae_abertas",
      "pacientes_aguardando_atendimento",
    ].some((metrica) => getMetricas(hospital, metrica, item));
  }

  function formatTime(time: string | null): string | null {
    if (time === null) {
      return null;
    }
    const regex = /^(\d{1,2}):(\d{2}):(\d{2})$/;
    const match = time.match(regex);
    if (match) {
      const [_, hours, minutes, seconds] = match;
      const formattedHours = hours.padStart(2, "0");

      return `${formattedHours}:${minutes}:${seconds}`;
    }
    return null;
  }

  const openModal = (hospital: string, especialidade: string) => {
    setModalHospital(hospital);
    setModalEspecialidade(especialidade);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalHospital("");
    setModalEspecialidade("");
  };

  const quadro = (hospital: any, item: any) => {
    return (
      <Card hospital={hospital}>
        <CardHeader>
          <h3>{item ?? hospital}</h3>
        </CardHeader>
        <FlexBox direction="column" gap="7px">
          <FlexBox gap="8px" justify="space-between">
            <Tooltip
              title="Ver pacientes aguardando atendimento (agora)"
              arrow
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -12],
                      },
                    },
                  ],
                },
              }}
            >
              <ChipsCard
                style={{ position: "relative", cursor: "pointer" }}
                onClick={() =>
                  openModal(hospital, item || selectedEspecialidades)
                }
              >
                <p>Aguardando Atendimento</p>
                <span>
                  {getMetricas(
                    hospital,
                    "pacientes_aguardando_atendimento",
                    item
                  ) | 0}
                </span>
                <PLineHeigth2>agora</PLineHeigth2>
                <ManageSearchIcon
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                    color: isHovered ? "black" : "#666666",
                    transform: isHovered ? "scale(1.3)" : "scale(1)",
                    transition: "color 0.3s ease, transform 0.3s ease",
                  }}
                />
              </ChipsCard>
            </Tooltip>
            <ChipsCard>
              <p>Tempo médio de espera</p>
              <span>
                {getMetricas(hospital, "tempo_atendimento", item, true)}
              </span>
              <PLineHeigth2>últimos 7 dias</PLineHeigth2>
            </ChipsCard>
            <ChipsCard>
              <FlexBox direction="column" gap="9px">
                <FlexBox justify="center" gap="5px">
                  <p>GAEs:</p>
                  <span>{getMetricas(hospital, "gae_abertas", item) | 0}</span>
                </FlexBox>
                <FlexBox justify="center" gap="5px">
                  <p>Desistentes:</p>{" "}
                  <span>
                    {getMetricas(hospital, "pacientes_desistentes", item) | 0}
                  </span>
                </FlexBox>
                <PLineHeigth2>últimas 24h</PLineHeigth2>
              </FlexBox>
            </ChipsCard>
          </FlexBox>

          <span style={{ fontSize: "13px", textAlign: "center" }}>
            <b>Classificação de Risco</b>
          </span>

          <div
            className="teste"
            style={{
              border: "1px solid #cecece",
              padding: "7px 10px",
              borderRadius: "10px",
            }}
          >
            <FlexBox direction="column" gap="6px">
              <div>
                <p
                  style={{
                    fontSize: "13px",
                    marginBottom: "5px",
                    textAlign: "center",
                  }}
                >
                  <b>Pacientes aguardando atendimento (agora)</b>
                </p>

                <FlexBox gap="8px" style={{ flexDirection: "row-reverse" }}>
                  {[
                    { color: "#007bff", risco: "azul" },
                    { color: "#077d04", risco: "verde" },
                    { color: "#ffce24", risco: "amarelo" },
                    { color: "#E96F19", risco: "laranja" },
                    { color: "#DE1E1F", risco: "vermelho" },
                  ].map(({ color, risco }) => (
                    <CardInfo key={risco} color={color}>
                      <FlexBox
                        direction="column"
                        align="center"
                        justify="center"
                      >
                        <IoIosPeople size="25px" />
                        <span>
                          {getMetricasRisco(risco, hospital, "risco", item) ||
                            0}
                        </span>
                      </FlexBox>
                    </CardInfo>
                  ))}
                </FlexBox>
              </div>
              <div>
                <p
                  style={{
                    fontSize: "13px",
                    marginBottom: "5px",
                    textAlign: "center",
                  }}
                >
                  <b>Tempo médio de atendimento (últimos 7 dias)</b>
                </p>

                <FlexBox gap="8px" style={{ flexDirection: "row-reverse" }}>
                  {[
                    { color: "#007bff", risco: "azul" },
                    { color: "#077d04", risco: "verde" },
                    { color: "#ffce24", risco: "amarelo" },
                    { color: "#E96F19", risco: "laranja" },
                    { color: "#DE1E1F", risco: "vermelho" },
                  ].map(({ color, risco }) => (
                    <CardInfo key={risco} color={color}>
                      <FlexBox
                        direction="column"
                        align="center"
                        justify="center"
                      >
                        <FaClock size="25px" />
                        <span
                        // style={
                        //   risco === "vermelho"
                        //     ? { fontSize: "11px" }
                        //     : undefined
                        // }
                        >
                          {risco === "vermelho"
                            ? "IMEDIATO"
                            : formatTime(
                                getMetricasRisco(
                                  risco,
                                  hospital,
                                  "tempo_atendimento",
                                  item
                                )
                              ) || "-"}
                        </span>
                      </FlexBox>
                    </CardInfo>
                  ))}
                </FlexBox>
              </div>
            </FlexBox>
          </div>
        </FlexBox>
      </Card>
    );
  };

  if (loading)
    return (
      <Full>
        <ReactLoading
          type={"spinningBubbles"}
          color="#fff"
          height={200}
          width={200}
        />
      </Full>
    );

  return (
    <div>
      <FlexBox>
        <CardContainer>
          {selectedHospital === "Todos"
            ? hospitalOrder.map(
                (item: any, index: number) =>
                  verificaHospital(item, null) && (
                    <div key={index}>{quadro(item, null)}</div>
                  )
              )
            : especialidades
                .filter((especialidade) =>
                  metricasEspecialidades[selectedHospital]?.hasOwnProperty(
                    especialidade
                  )
                )
                .map(
                  (especialidade: any, index: number) =>
                    verificaHospital(selectedHospital, especialidade) && (
                      <div key={index}>
                        {quadro(selectedHospital, especialidade)}
                      </div>
                    )
                )}
        </CardContainer>
        <FlexBox
          direction="column"
          style={{
            width: "unset",
            minWidth: "315px",
            height: "100%",
            backgroundColor: "white",
            margin: "0 16px 16px 0",
            borderRadius: "8px",
            border: "6px solid gray",
            marginTop: "16px",
          }}
        >
          <Typography
            style={{
              backgroundColor: "gray",
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Selecione:
          </Typography>
          <Accordion
            expanded={expanded === "hospitais"}
            onChange={handleAccordionChange("hospitais")}
            style={{
              boxShadow: "unset",
              marginBottom: 0,
              borderBottom: "2px solid gray",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="hospitais-content"
              id="hospitais-header"
              style={{
                margin: 0,
              }}
            >
              <Typography component="div">
                Hospital
                {expanded === "especialidades" && (
                  <Chip
                    sx={{
                      backgroundColor:
                        macrorregiaoColorMap[selectedHospitalOption] || "gray",
                      color: "white",
                      position: "relative",
                      top: "-1px",
                      left: "5px",
                    }}
                    label={selectedHospitalOption}
                  />
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ToggleButtonGroup
                orientation="vertical"
                value={selectedHospitalOption}
                exclusive
                onChange={handleHospitalChange}
                style={{
                  width: "100%",
                }}
              >
                {hospitalsList.map((option) => (
                  <ToggleButton key={option} value={option} aria-label={option}>
                    <p
                      style={{
                        borderLeft: "solid 2px " + macrorregiaoColorMap[option],
                        paddingLeft: "10px",
                        width: "100%",
                      }}
                    >
                      {option}
                    </p>
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "especialidades"}
            onChange={handleAccordionChange("especialidades")}
            style={{
              marginTop: 0,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="especialidades-content"
              id="especialidades-header"
            >
              <Typography component="div">
                Especialidade
                {expanded === "hospitais" && (
                  <Chip
                    sx={{
                      backgroundColor:
                        especialidadesColorMap[selectedOption] || "gray",
                      color: "white",
                      position: "relative",
                      top: "-1px",
                      left: "5px",
                      marginRight: "10px",
                    }}
                    label={selectedOption}
                  />
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ToggleButtonGroup
                orientation="vertical"
                value={selectedOption}
                exclusive
                onChange={handleEspecialidadeChange}
                style={{
                  width: "100%",
                }}
              >
                {listOptinsEspecialidades.map((option) => (
                  <ToggleButton
                    key={option.value}
                    value={option.value}
                    aria-label={option.value}
                    // sx={{
                    //   backgroundColor:
                    //     especialidadesColorMap[option.label] || "#cccccc",
                    //   color: especialidadesColorMap[option.label],
                    //   "&.Mui-selected": {
                    //     backgroundColor: "blue",
                    //     color: "white",
                    //   },
                    // }}
                  >
                    <p
                      style={{
                        borderLeft:
                          "solid 2px " + especialidadesColorMap[option.label],
                        paddingLeft: "10px",
                        width: "100%",
                      }}
                    >
                      {option.label}
                    </p>
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </AccordionDetails>
          </Accordion>
        </FlexBox>
      </FlexBox>
      <DetalhadoModal
        open={isModalOpen}
        onClose={closeModal}
        hospital={modalHospital}
        especialidade={modalEspecialidade}
      />
    </div>
  );
};

export default DataFetcher;
